import {
  METRIC_CONVERSIONS,
  UNIT_BOX,
  UNIT_DOZEN,
  UNIT_G,
  UNIT_KG,
  UNIT_L,
  UNIT_ML,
  UNIT_PACKET,
  UNIT_PIECE,
} from "./common";
import type { PackDef, UnitDef } from "./types";

const UNIT_CARTON: UnitDef = {
  code: "ctn",
  name: { en: "Carton", bn: "কার্টন" },
  fractional: false,
};
const UNIT_SACK: UnitDef = { code: "sack", name: { en: "Sack", bn: "বস্তা" }, fractional: false };
const UNIT_MAUND: UnitDef = { code: "maund", name: { en: "Maund", bn: "মণ" }, fractional: true };

export const WHOLESALE_PACK: PackDef = {
  id: "wholesale",
  version: 1,
  available: true,
  name: { en: "Wholesale & distribution", bn: "পাইকারি ও ডিস্ট্রিবিউশন" },
  description: {
    en: "Dealers, distributors and wholesalers selling by carton and sack, often on credit",
    bn: "কার্টন ও বস্তায়, প্রায়ই বাকিতে বিক্রি করা ডিলার, ডিস্ট্রিবিউটর ও পাইকার",
  },
  icon: "warehouse",
  modules: {
    variants: true,
    batches: false,
    expiry: false,
    serials: false,
    vat: false,
    multi_branch: false,
    storefront: false,
    loans: false,
  },
  baseUnits: [
    UNIT_PIECE,
    UNIT_KG,
    UNIT_G,
    UNIT_L,
    UNIT_ML,
    UNIT_DOZEN,
    UNIT_PACKET,
    UNIT_BOX,
    UNIT_CARTON,
    UNIT_SACK,
    UNIT_MAUND,
  ],
  unitConversions: [...METRIC_CONVERSIONS, { from: "maund", to: "kg", factor: 40 }],
  categories: [
    { en: "Rice & grains", bn: "চাল ও শস্য" },
    { en: "Edible oil", bn: "ভোজ্য তেল" },
    { en: "Lentils & spices", bn: "ডাল ও মসলা" },
    { en: "Beverages", bn: "পানীয়" },
    { en: "Snacks & biscuits", bn: "স্ন্যাকস ও বিস্কুট" },
    { en: "Toiletries", bn: "প্রসাধনী" },
    { en: "Detergents", bn: "ডিটারজেন্ট" },
    { en: "Plastic goods", bn: "প্লাস্টিক পণ্য" },
  ],
  customFields: [
    {
      key: "route",
      entity: "customer",
      type: "text",
      label: { en: "Route / market", bn: "রুট / বাজার" },
      required: false,
      searchable: true,
    },
  ],
  priceTiers: [
    { en: "Dealer", bn: "ডিলার" },
    { en: "Retailer", bn: "খুচরা বিক্রেতা" },
  ],
  receiptTemplate: "retail",
  dashboard: [
    "sales_today",
    "gross_profit",
    "cash_in_hand",
    "dues_receivable",
    "dues_payable",
    "low_stock",
    "sales_trend",
  ],
};
